export default {"src":"/_next/static/media/filter.06d62b10.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};